var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyCart = function SvgEmptyCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 228,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    stroke: "#737E8C",
    strokeWidth: 2.12,
    d: "M41.942 42.5c11.108-.776 18.904 4.352 27.778 11.065 13.629 10.37 28.969 19.374 45.718 24.023 17.043 4.748 35.228 5.467 52.984 5.467h.007c6.072-.043 12.125-.192 18.055-.319h-.001c4.057-.087 8.431-.59 12.883-1.127 4.471-.538 9.027-1.109 13.525-1.346 9.005-.476 17.552.401 24.36 5.377a27.88 27.88 0 0 1 10.001 16.97l.003.019.004.019c2.446 11.603 2.303 26.038-.96 39.455-3.266 13.429-9.623 25.702-19.48 33.144-10.796 8.128-24.249 11.545-38.241 12.428-13.991.883-28.431-.773-41.131-2.709h-.002c-28.947-4.377-57.79-12.005-84.01-25.105l-.002-.001-2.142-1.077c-10.758-5.477-22.215-12.303-32.128-20.62-10.577-8.874-19.342-19.4-23.666-31.738v-.002C2.593 98.187.61 88.213 1.147 78.748c.538-9.456 3.583-18.301 10.625-24.476a51.74 51.74 0 0 1 30.153-11.771h.009zM125.857 218.616c21.475 0 40.906.543 54.96 1.42 7.031.438 12.695.96 16.588 1.534 1.873.276 3.297.56 4.257.841-.96.28-2.384.564-4.257.841-3.893.574-9.557 1.095-16.588 1.534-14.054.877-33.485 1.419-54.96 1.419-21.474 0-40.905-.542-54.96-1.419-7.03-.439-12.695-.96-16.588-1.534-1.873-.277-3.297-.561-4.257-.841.96-.281 2.384-.565 4.257-.841 3.893-.574 9.557-1.096 16.588-1.534 14.055-.877 33.486-1.42 54.96-1.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#737E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.12,
    d: "m16.047 35.253 27.557-2.332A15.05 15.05 0 0 1 59.312 43.52l26.413 88.396-5.172 9.264a15.09 15.09 0 0 0 .492 15.503 15.09 15.09 0 0 0 13.901 6.882l105.779-8.988"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#737E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.12,
    d: "m63.26 56.938 122.949-10.43a8.096 8.096 0 0 1 8.712 9.18l-8.331 60.138a8.12 8.12 0 0 1-7.249 6.953l-93.611 9.137zM106.713 183.83c5.514 0 9.984-4.47 9.984-9.984s-4.47-9.984-9.984-9.984-9.984 4.47-9.984 9.984 4.47 9.984 9.984 9.984M176.244 177.937c5.514 0 9.984-4.47 9.984-9.984s-4.47-9.984-9.984-9.984-9.984 4.47-9.984 9.984 4.47 9.984 9.984 9.984"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#737E8C",
    strokeWidth: 2.12,
    d: "m11.982 33.794 25.981-2.204a3.032 3.032 0 0 1 .513 6.041l-25.981 2.205a3.032 3.032 0 0 1-.513-6.042Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#737E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.12,
    d: "M115.023 103.383a17.11 17.11 0 0 1 15.508-14.822 17.11 17.11 0 0 1 17.795 11.982"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    stroke: "#737E8C",
    strokeWidth: 2.12,
    d: "M148.601 76.822a1.315 1.315 0 1 1-.001 2.63 1.315 1.315 0 0 1 .001-2.63ZM110.972 80.001a1.315 1.315 0 1 1-.002 2.63 1.315 1.315 0 0 1 .002-2.63Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#737E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.12,
    d: "M44.094 170.899v9.137M39.541 175.457h9.115M189.748 1.06v9.115M185.191 5.618h9.116M81.828 28.3v9.115M77.248 32.857h9.136"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#737E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.12,
    d: "M212.492 61.814a2.162 2.162 0 1 0 0-4.325 2.162 2.162 0 0 0 0 4.325"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#737E8C",
    stroke: "#737E8C",
    strokeWidth: 2.12,
    d: "M131.685 39.28a1.018 1.018 0 1 1-.002 2.035 1.018 1.018 0 0 1 .002-2.035Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    stroke: "#737E8C",
    strokeWidth: 2.12,
    d: "M145.632 190.041a1.017 1.017 0 1 1 0 2.034 1.017 1.017 0 0 1 0-2.034Z"
  })));
};
export default SvgEmptyCart;